exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".paddingTop--3eflU{margin-top:5px;width:100%}", "", {"version":3,"sources":["/workspace/src/widget/event_layouts/top_padder/styles.scss"],"names":[],"mappings":"AAAA,mBACE,eAAe,AACf,UAAW,CACZ","file":"styles.scss","sourcesContent":[".paddingTop {\n  margin-top: 5px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"paddingTop": "paddingTop--3eflU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./node_modules/postcss-loader/lib??ref--4-2!./node_modules/sass-loader/lib/loader.js??ref--4-3!./src/widget/event_layouts/top_padder/styles.scss
// module id = 1135
// module chunks = 0